import { gsap, ScrollSmoother, ScrollTrigger, SplitText } from '../lib/gsap';

export function initAllScript() {
	// console.log('limetheme is working');
	gsapAnimations();
	imageReveal();
}

export function initScrollSmoother() {
	gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
	const content = document.getElementById('smooth-content');
	const wrapper = document.getElementById('smooth-wrapper');
	if (!content && !wrapper) return;
	ScrollSmoother.create({
		wrapper: wrapper,
		content: content,
		smooth: 0.8, // how long (in seconds) it takes to "catch up" to the native scroll position
		effects: true, // looks for data-speed and data-lag attributes on elements
		smoothTouch: false, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
	});
}

function gsapAnimations() {
	const heroAnimEl = document.querySelector('.featured-project-wrapper');
	if (!heroAnimEl) return;
	const textElements = gsap.utils.toArray('.sub-title', heroAnimEl);
	if (textElements.length === 0) return [];

	let tl = gsap.timeline({ defaults: { duration: 1.2, ease: 'power2.out' } });
	tl.to(heroAnimEl, { scaleX: 1 }).to(textElements, { y: 0, opacity: 1 });
}

function imageReveal() {
	let revealContainers = document.querySelectorAll('.image-reveal');
	if (revealContainers.length === 0) return;
	revealContainers.forEach((container) => {
		let image = container.querySelector('img');
		let origin = container.dataset.origin === 'right';
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: container,
				toggleActions: 'restart none none reset',
			},
		});

		tl.set(container, { autoAlpha: 1 });
		tl.from(container, 1.5, {
			xPercent: origin ? 100 : -100,
			ease: 'power2.out',
		});
		tl.from(image, 1.5, {
			xPercent: origin ? -100 : 100,
			scale: 1.3,
			delay: -1.5,
			ease: 'power2.out',
		});
	});
}

gsap.registerPlugin(SplitText);

document.fonts.ready.then(() => {
	const animHeadings = document.querySelectorAll(
		'[data-animate-heading], h1, h2, h3, h4, .h1, .h2, .h3, .h4, .sub-title'
	);
	if (!animHeadings.length) return;
	animHeadings.forEach((animHeading) => {
		if (animHeading.classList.contains('no-split')) return;

		const hasWordSplit = !(
			animHeading.classList.contains('no-word-split') ||
			animHeading.matches('h3, .h3, h4, .h4, sub-title')
		);

		const split = new SplitText(animHeading, {
			type: hasWordSplit ? 'lines,words' : 'lines',
			linesClass: 'line line-mask',
			wordsClass: hasWordSplit ? 'word' : '',
			reduceWhiteSpace: false,
		});

		const lines = split.lines;
		const words = hasWordSplit ? split.words : null;

		gsap.set(animHeading, { autoAlpha: 1 });

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: animHeading,
				start: 'top 90%',
				end: 'bottom 50%',
				toggleActions: 'play none none none',
			},
		});

		// Lines animation
		tl.from(lines, {
			yPercent: 100,
			autoAlpha: 0,
			ease: 'power2.out',
			duration: 0.8,
			delay: 0.25,
			stagger: 0.1,
		});

		// Words animation (only if enabled)
		if (hasWordSplit && words && words.length) {
			tl.from(
				words,
				{
					yPercent: 20,
					autoAlpha: 0,
					ease: 'power2.out',
					duration: 0.6,
					stagger: {
						each: 0.1,
					},
				},
				'<0.1'
			);
		}

		// Resize handling
		let resizeTimeout;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				split.revert();

				new SplitText(animHeading, {
					type: hasWordSplit ? 'lines,words' : 'lines',
					linesClass: 'line line-mask',
					wordsClass: hasWordSplit ? 'word' : '',
					reduceWhiteSpace: false,
				});

				gsap.set(animHeading, { autoAlpha: 1 });
			}, 200);
		});
	});
});


// about team section
const sections = document.querySelectorAll('.about-team-section');

if (sections.length) {
	sections.forEach((section) => {
		const members   = section.querySelectorAll('.about-team-section__member');
		const panelImg  = section.querySelector('#team-panel-img');
		const panelLink = section.querySelector('#team-panel-link');

		if (!members.length) return;

		let swapTimer = null;

		function activateMember(member) {
			if (member.classList.contains('is-active')) return;

			// Update ARIA states
			members.forEach((m) => {
				m.classList.remove('is-active');
				m.setAttribute('aria-pressed', 'false');
			});
			member.classList.add('is-active');
			member.setAttribute('aria-pressed', 'true');

			// Swap image
			if (panelImg) {
				const imgSrc   = member.dataset.teamImg      || '';
				const imgLarge = member.dataset.teamImgLarge || imgSrc;
				const imgAlt   = member.dataset.teamImgAlt   || '';
				const imgW     = member.dataset.teamImgW     || '';
				const imgH     = member.dataset.teamImgH     || '';

				// Fade out → swap → fade in
				panelImg.style.opacity = '0';
				panelImg.style.transition = 'opacity 0.3s ease';

				// Cancel a pending swap so fast hovering only shows the last member
				clearTimeout(swapTimer);
				swapTimer = setTimeout(() => {
					panelImg.src    = imgSrc;
					panelImg.srcset = imgLarge ? `${imgLarge} 1x` : '';
					panelImg.alt    = imgAlt;
					if (imgW) panelImg.width  = imgW;
					if (imgH) panelImg.height = imgH;

					panelImg.style.opacity = '1';
				}, 300);
			}

			// Swap link
			if (panelLink) {
				const linkUrl = member.dataset.teamLink || '';

				if (linkUrl) {
					panelLink.href = linkUrl;
					panelLink.classList.remove('about-team-section__link--hidden');
					panelLink.removeAttribute('aria-hidden');
					panelLink.removeAttribute('tabindex');
				} else {
					panelLink.href = '#';
					panelLink.classList.add('about-team-section__link--hidden');
					panelLink.setAttribute('aria-hidden', 'true');
					panelLink.setAttribute('tabindex', '-1');
				}
			}
		}

		members.forEach((member) => {
			// Hover (pointerenter also fires on touch tap)
			member.addEventListener('pointerenter', () => activateMember(member));

			// Keyboard: Enter or Space
			member.addEventListener('keydown', (e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					activateMember(member);
				}
			});
		});
	});


}


// Projects filtering
const projectFilterButtons = document.querySelectorAll('.projects-filter-section a, .projects-filter-section button');
if (projectFilterButtons.length) {
	projectFilterButtons.forEach((button) => {
		button.addEventListener('click', (e) => {
			// when the button is clicked, add open class to this and the filter-panel that has a matching id with the button's aria-controls attribute
			const controlsId = button.getAttribute('aria-controls');
			const panel = document.getElementById(controlsId);
			if (panel) {
				// remove open class from all other buttons and panels
				projectFilterButtons.forEach((btn) => {
					if (btn === button) return;
					btn.classList.remove('is-open');
					const btnControlsId = btn.getAttribute('aria-controls');
					const btnPanel = document.getElementById(btnControlsId);
					if (btnPanel) {
						btnPanel.classList.remove('is-open');
					}
				});

				// toggle open class on the clicked button and its panel
				if (button.classList.contains('is-open')) {
					button.classList.remove('is-open');
					panel.classList.remove('is-open');
				} else {
					button.classList.add('is-open');
					panel.classList.add('is-open');
				}
			}
		});
	});
}

// Services list – touch toggle
const serviceListItems = document.querySelectorAll('.services-category-section__list-item');
if (serviceListItems.length && window.matchMedia('(hover: none)').matches) {
    serviceListItems.forEach((item) => {
        item.addEventListener('click', () => {
            const isOpen = item.classList.contains('is-open');
            serviceListItems.forEach((i) => i.classList.remove('is-open'));
            if (!isOpen) item.classList.add('is-open');
        });
    });
}

// News filtering
const newsFilterButtons = document.querySelectorAll('.news-filter-section a, .news-filter-section button');
if (newsFilterButtons.length) {
    newsFilterButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const controlsId = button.getAttribute('aria-controls');
            const panel = document.getElementById(controlsId);

            if (panel) {
                // Close all other tabs + panels
                newsFilterButtons.forEach((btn) => {
                    if (btn === button) return;
                    btn.classList.remove('is-open');
                    const otherPanelId = btn.getAttribute('aria-controls');
                    const otherPanel   = document.getElementById(otherPanelId);
                    if (otherPanel) otherPanel.classList.remove('is-open');
                });

                // Toggle clicked tab + its panel
                if (button.classList.contains('is-open')) {
                    button.classList.remove('is-open');
                    panel.classList.remove('is-open');
                } else {
                    button.classList.add('is-open');
                    panel.classList.add('is-open');
                }
            }
        });
    });
}